import api from "@/modules/outlets/services/outlets";

const state = () => ({
    outlets: [],
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    },
})

const getters = {
}

const actions = {
    loadOutlets({commit}) {
        api.getOutlets().then(result => {
            commit('SAVE_OUTLET', result.data);
        }).catch(error => {
            throw new Error(`API ${error}`);
        });
    },
    addOutlet ({ commit,dispatch }, payload) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        if (!payload) {
            // do not add empty todos
            return
        }
        api.postOutlet(payload)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('ADD_OUTLET', r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION002', extra: 'point de vente' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'point de vente' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    updateOutlet({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.putOutlet(payload.id, payload)
            .then((r) => {
                commit('UPDATE_OUTLET', r.data);
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'point de vente' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'point de vente' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    deleteOutlet({ commit,dispatch }, id){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.deleteOutlet(id)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('DELETE_OUTLET',id)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION003', extra: 'point de vente' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION003', extra: 'point de vente' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            })

    },
}

const mutations = {
    ADD_OUTLET (state, payload) {
        state.outlets.push(payload)
    },
    UPDATE_OUTLET (state,payload){
        state.outlets = state.outlets.map(pointvente => {
            if (pointvente.id === payload.id) {
                return Object.assign({}, pointvente, payload.data)
            }
            return pointvente
        })
    },
    DELETE_OUTLET (state, id){
        const index = state.outlets.findIndex(c => c.id === id);
        state.outlets.splice(index, 1);
    },
    SAVE_OUTLET(state, outlets) {
        state.outlets = outlets;
    },

    // Result api
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
